import React, { useState } from 'react';
import { FiVolume2, FiVolumeX } from 'react-icons/fi';
import { useLanguage } from '../i18n';
import { isSfxOn, toggleSfx } from '../utils/sfx';

/**
 * Button-sound switch (speaker icon). Shown next to the dark/light switch in the
 * navbar on every screen size, and as a labelled row with a switch inside the
 * account dropdown — so phone users can mute the click sounds easily.
 * The choice is saved in localStorage (`ms_sfx`, on by default).
 */
export default function SoundToggle({ className = '', withLabel = false }) {
  const { t } = useLanguage();
  const [on, setOn] = useState(isSfxOn);

  const flip = () => {
    const next = toggleSfx();          // plays a short confirmation when turning on
    setOn(next);
  };

  if (withLabel) {
    return (
      <button
        type="button"
        data-sfx="none"
        onClick={flip}
        className={`w-full flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition ${className}`}
        aria-pressed={on}
      >
        {on ? <FiVolume2 className="w-4 h-4" /> : <FiVolumeX className="w-4 h-4" />}
        {on ? t('soundOff') : t('soundOn')}
        <span className={`ml-auto w-9 h-5 rounded-full relative transition ${on ? 'bg-[#0B5FDB]' : 'bg-gray-300 dark:bg-gray-600'}`}>
          <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow transition-all ${on ? 'left-[18px]' : 'left-0.5'}`} />
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      data-sfx="none"
      onClick={flip}
      className={`p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition ${className}`}
      style={{ color: on ? '#0B5FDB' : undefined }}
      title={on ? t('soundOff') : t('soundOn')}
      aria-label={t('soundEffects')}
      aria-pressed={on}
    >
      {on
        ? <FiVolume2 className="w-5 h-5 sm:w-4 sm:h-4" />
        : <FiVolumeX className="w-5 h-5 sm:w-4 sm:h-4 text-gray-500 dark:text-gray-400" />}
    </button>
  );
}
